// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3N9iS","title":"FrontImage_title__2Zz3P"};